/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface IAdressErrorMessage {
    message: string;
}

/**
 * Address error message.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressErrorMessageFunctionComponent: React.FC<IAdressErrorMessage> = (props: IAdressErrorMessage) => {
    const { message } = props;

    return <p className='msc-address-form__error-message'>{message}</p>;
};

export default AddressErrorMessageFunctionComponent;
